import api from '../utils/api';

export const getAll = (config = {}) => {
    const { options } = config;
    return api({
        url: '/api/manufacturers/get-all',
        method: 'GET',
        ...options,
    });
};
export const edit = (config = {}) => {
    const { options } = config;
    return api({
        url: '/api/manufacturers/edit',
        method: 'POST',
        ...options,
    });
};
export const add = (config = {}) => {
    const { options } = config;
    return api({
        url: '/api/manufacturers/add',
        method: 'POST',
        ...options,
    });
};
export const downloadPriceList = (config = {}) => {
    const { options } = config;
    return api.post(`/api/manufacturers/download-price-list`, options, {
        responseType: 'blob',
    });
};
export const deleteManufacturers = (config = {}) => {
    return api.delete('/api/manufacturers/delete/' + config);
};

export const getAllV2 = (districtId = 0, config = {}) => {
    const { options } = config;
    return api({
        url: `/api/manufacturers/get-all-v2/${districtId}`,
        method: 'GET',
        ...options,
    });
};

export const addV2 = (config = {}) => {
    const { options } = config;
    return api({
        url: '/api/manufacturers/add-v2',
        method: 'POST',
        ...options,
    });
};



export const getManufacturerQuotes = (filter) => {
    var data = { ...filter };
    return api.post(`/api/manufacturers/get-manufacturer-quotes/`, data);
}

export const getAllDistricts = (config = {}) => {
    const { options } = config;
    return api({
        url: '/api/manufacturers/get-all-districts',
        method: 'GET',
        ...options,
    });
};

// Manufacturer User
export const saveManufacturerUser = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `api/manufacturers/add-user`,
        method: "POST",
        data: data,
        ...options,
    });
};

export const editManufacturerUser = (config = {}) => {
    const { data, options } = config;
    return api({
        url: `api/manufacturers/edit-user`,
        method: "POST",
        data: data,
        ...options,
    });
};

export const deleteManufacturerUser = ({ manufacturerId, userId, options = {} }) => {
    return api({
        url: `api/manufacturers/delete-user/${manufacturerId}/${userId}`,
        method: "DELETE",
        ...options,
    });
};

export const getManufacturerUsers = (manufacturerId, options = {}) => {
    return api({
        url: `api/manufacturers/get-users/${manufacturerId}`,
        method: "GET",
        ...options,
    });
};